<template>
  <div class="myBill manage"
       v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 弹出框 -->
    <div class="pop">
      <!-- 添加周期账单dialog -->
      <!-- <el-dialog title="添加周期账单"
                 :visible.sync="dialogTableVisible"
                 width="20%"
                 class="addPeriod">
        <div class="period">
          <el-form :model="addPeriod_data">
            <el-form-item label="用户ID"
                          prop="uid"
                          :rules="[
      { required: true, message: '请输入用户ID', trigger: 'blur' },
    ]">
              <el-input v-model="addPeriod_data.uid"
                        placeholder="请输入用户ID"></el-input>
            </el-form-item>
            <el-form-item label="截至时间"
                          prop="timeslot"
                          :rules="[
      { required: true, message: '请选择截止时间', trigger: 'blur' },
    ]">
              <el-date-picker v-model="addPeriod_data.timeslot"
                              type="datetime"
                              placeholder="请选择截止时间"
                              align="right"
                              default-time="12:00:00"
                              value-format="yyyy-MM-dd"
                              :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="data_detection()">添 加</el-button>
        </span>
      </el-dialog> -->
      <!-- 确定付款审核订单dialog -->
      <el-dialog title="设置状态"
                 :visible.sync="audit_show"
                 width="600px"
                 class="auditClass">
        <el-form :model="audit"
                 label-width="100px"
                 ref="audit">
          <el-form-item :label="is_order?'订单ID:':'账单号:'">
            <span>{{audit_id}}</span>
          </el-form-item>

          <el-form-item label="设置说明:"
                        prop="info"
                        :rules="[
                      { required: true, message: '审核说明不能为空'},
                      { min: 3, max: 100, message: '长度在 3 到 100个字符'}]">
            <el-input v-model="audit.info"
                      placeholder="请说明设置状态原因，如：确定已经/未收到钱款"></el-input>
          </el-form-item>

          <el-form-item label="审核状态"
                        prop="status"
                        :rules="[
                      { required: true, message: '审核状态不能为空', trigger: 'change' },]">
            <el-select v-model="audit.status"
                       placeholder="请选择">
              <el-option v-for="item in status_data"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="公/私:"
                        v-if="audit.status!=0"
                        prop="public"
                        :rules="[
                      { required: true, message: '公/私不能为空', trigger: 'change' },]">
            <el-select v-model="audit.public"
                       placeholder="请选择">
              <el-option v-for="item in audit_data"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付途径:"
                        v-if="audit.status!=0"
                        prop="pay_type"
                        :rules="[
                      { required: true, message: '支付途径不能为空', trigger: 'change' },]">
            <el-select v-model="audit.pay_type"
                       placeholder="请选择">
              <el-option v-for="item in pay_type"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="audit_show = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitForm('audit')">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!--  -->
    <div class="myBill_top">
      <div class="top_item">
        <span>时间查询</span>
        <el-date-picker v-model="time_inquire"
                        size="mini"
                        @change='selectTime'
                        type="daterange"
                        unlink-panels
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </div>

      <div class="top_item">
        <span>用户手机查询</span>
        <el-input v-model="inquire.mobile"
                  size="mini"
                  type="number"
                  @keyup.enter.native="getALLapiManageBill"
                  placeholder="请输入用户手机号码查询"></el-input>
      </div>

      <div class="top_item">
        <span>账单号查询</span>
        <el-input v-model="inquire.payid"
                  size="mini"
                  type="number"
                  @keyup.enter.native="getALLapiManageBill"
                  placeholder="请输入账单号查询"></el-input>
      </div>

    </div>

    <div class="myBill_table">
      <el-table :data="tableData"
                v-loading="table_loading"
                height="100%"
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.fdlist"
                      row-class-name='interior_table'
                      style="width: 100%">
              <el-table-column prop="payid"
                               label="账单号"
                               width="180">
              </el-table-column>
              <el-table-column prop="name"
                               label="创建时间"
                               width="180">
                <template slot-scope="scope">
                  {{common.formatDate(scope.row.createtime)}}
                </template>
              </el-table-column>
              <el-table-column label="状态"
                               width="120">
                <template slot-scope="scope">
                  <span>{{scope.row.status==0?'未付款':scope.row.status==1?'待审核':scope.row.status==2?'已付款':scope.row.status==3?'部分付款':scope.row.status==-1?'周期账单':'异常'}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="address"
                               label="账单名称"
                               width="150px">
                <template slot-scope="scope">
                  {{scope.row.info.substring(0, scope.row.info.indexOf("【"))||scope.row.info}}
                </template>
              </el-table-column>
              <el-table-column prop="allprice"
                               label="金额（ CNY ）">
              </el-table-column>
              <el-table-column prop="allprice"
                               label="操作"
                               align="right">
                <template slot-scope="scope">
                  <div class="operationClass"
                       v-if="scope.row.status!=2&&scope.row.status>=0">
                    <el-button size="mini"
                               @click="payment(scope.row.payid,1,false)">修改状态</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="createtime"
                         label="订单时间"
                         width="200">
        </el-table-column>

        <el-table-column label="付款状态"
                         prop="ozt"
                         width="150px">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status &lt; 6?'warning': scope.row.status == 6?'info':scope.row.status> 6?'success':'danger'">{{scope.row.status &lt; 6?'未支付': scope.row.status == 6?'审核中':scope.row.status> 6?'已付款':'错误'}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="sjgj"
                         label="收件国家"
                         width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.sjgj">{{scope.row.sjgj}}</span>
            <span v-else
                  style='color:#999'>获取失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="bjname"
                         label="下单报价"
                         width="200px">
        </el-table-column>
        <el-table-column label="类型"
                         width="150px">
          <template slot-scope="scope">
            <span> {{scope.row.type==1?'商业件':'集运件'}}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单总额 ( CNY ) "
                         width="200px">
          <template slot-scope="scope">
            <span> {{scope.row.allprice}}</span>
          </template>
        </el-table-column>

        <el-table-column>
          <template slot="header"
                    slot-scope="scope">
            <div class="header_view">
              <el-input v-model="inquire.wlnum"
                        @keyup.enter.native="getALLapiManageBill(scope.row)"
                        size="mini"
                        placeholder="输入物流号回车查询" />
              <el-button size="mini"
                         @click="reset_inquire">
                重置查询
              </el-button>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="operationClass">
              <el-button size="mini"
                         type="primary"
                         v-if="scope.row.status<=6"
                         @click="payment(scope.row.id, 1,true)">设置状态</el-button>
            </div>

          </template>

        </el-table-column>

      </el-table>
    </div>

    <el-pagination background
                   class="pagination"
                   layout="prev, pager, next"
                   :current-page.sync='page_size'
                   @current-change='handleCurrentChange'
                   :total="page_number"
                   :page-size='page_sizes'>
    </el-pagination>

  </div>
</template>

<script>
import { apiManageBill, apiTimeBill, apiAddPeriodBill, apiPayAudit } from '@/request/api'
import common from '@/assets/js/common'
export default {

  name: 'ManagementBills',
  data () {
    return {
      common,
      time_inquire: '',
      fullscreenLoading: false,
      //付款审核数据
      audit: {
        type: '',
        orderid: '',
        info: '',
        public: '',
        pay_type: '',
        status: 2
      },
      audit_id: '',
      audit_type: '',
      is_order: '',
      //确定付款审核
      audit_show: false,
      //付款审核选择器数据
      status_data: [
        {
          label: "未付款",
          value: 0
        },
        {
          label: "付款待审核",
          value: 1
        }, {
          label: "已付款",
          value: 2
        }
      ],
      audit_data: [
        {
          label: '对公',
          value: 1
        },
        {
          label: '对私',
          value: 2
        }
      ],
      pay_type: [
        {
          label: '微信',
          value: 1
        }, {
          label: '支付宝',
          value: 2
        }, {
          label: '银行转账',
          value: 3
        }, {
          label: '系统钱包',
          value: 4
        }, {
          label: '现金',
          value: 5
        }, {
          label: '其他',
          value: 6
        }
      ],
      //添加周期账单的数据
      addPeriod_data: {
        uid: '',
        timeslot: ''
      },

      //添加周期账单
      dialogTableVisible: false,
      //总数据条数
      page_number: 400,
      page_number_2: 400,
      //控制当前页
      page_size: 1,
      page_size_2: 1,
      //控制每一页显示多少条
      page_sizes: 12,
      page_sizes_2: 10,
      //报价数据
      bjlist: '',
      //仓库数据
      cklist: '',
      //渠道数据
      qdlist: '',
      //记录已加载了的数据避免重复加载
      record: [],
      //临时数据
      test: {},
      //周期订单
      period_order: {
        // otherpriceinfo
      },
      //查询周期订单
      soid: '',
      //是否显示对账单
      statement_account: false,
      //是否显示操作
      operation: false,
      //数据加载
      table_loading: false,
      //账单列表
      tableData: [],
      // 周期账单列表
      periodData: [],
      getRowKey (row) {
        return row.id
      },
      getRowKey_2 (row) {
        return row.id
      },
      expand: [],
      expand_2: [],

      inquire: {
        //渠道id
        qdid: '',
        //仓库id
        ckid: '',
        //推荐人手机号
        tjmobile: '',
        //用户手机号
        mobile: '',
        // 状态
        status: '',
        // 账单类型
        fdtype: '',
        // 结算类型
        type: '',
        // 报价方案ID
        bjid: '',
        // 物流单号
        wlnum: '',
        // 账单号
        payid: '',
        // 订单号
        orderid: '',
        // 对公\对私
        ptp: '',
        // 时间段
        zdtime_start: '',
        zdtime_end: '',
      },
      //账单状态
      finance_status: [
        {
          value: 0,
          label: '未付款'
        }, {
          value: 1,
          label: '待审核已付款'
        }, {
          value: 2,
          label: '已付款'
        },
        // {
        //   value: 3,
        //   label: '部分付款'
        // },
        {
          value: 4,
          label: '已开票'
        }
      ],
      //账单类型
      finance_type: [
        {
          value: 0,
          label: '订单'
        }, {
          value: 1,
          label: '改址费'
        }, {
          value: 2,
          label: '附加费'
        }, {
          value: 3,
          label: '待回收货款'
        }, {
          value: 4,
          label: '手续费帐单'
        }, {
          value: 5,
          label: '报关费帐单'
        }, {
          value: 6,
          label: '退货帐单'
        }, {
          value: 7,
          label: '其他待定'
        },
      ],
      //结算类型
      close_account_type: [
        {
          value: 1,
          label: '现结'
        }, {
          value: 2,
          label: '周期帐单'
        },
      ],
      //是否开发票
      is_invoice: [
        {
          value: '1',
          label: '开发票'
        }, {
          value: '2',
          label: '不开票'
        }
      ],
      //方案id
      bjlist: [],
      //时间处理
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7;
        }
      },
    }

  },
  methods: {
    // 选择筛选时间
    selectTime (e) {
      if (e) {
        this.inquire.zdtime_start = e[0]
        this.inquire.zdtime_end = e[1]
        this.getALLapiManageBill()
      } else {
        this.inquire.zdtime_start = ''
        this.inquire.zdtime_end = ''
      }

    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将修改' + (this.is_order ? '订单' : '账单') + '的支付状态, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.pay_audit()
          }).catch(() => {

          });
        } else {
          return false;
        }
      });
    },
    //付款审核确定
    async pay_audit () {
      this.fullscreenLoading = true
      let res = await apiPayAudit({
        info: this.audit.info,
        status: this.audit.status,
        orderid: this.is_order ? this.audit_id : '',
        payid: this.is_order ? '' : this.audit_id,
        type: this.audit_type,
        ptp: this.audit.public,
        paytype: this.audit.pay_type,
      })
      if (res.errno == 0) {
        this.$message.success(res.message)
        this.audit_show = false
        this.getALLapiManageBill()
      }
      else {
        this.$message.error(res.message)
      }
      this.fullscreenLoading = false
    },
    //跳转详情
    // skip_particulars (row) {
    //   this.$router.push({
    //     path: '/index/BillingDetails',
    //     query: {
    //       id: row.id,
    //       payid: row.payid
    //     }
    //   })
    // },

    //检测周期结算账单提交数据
    // data_detection () {
    //   if (this.addPeriod_data.uid == '') {
    //     return this.$message.error('请输入用户ID')
    //   } else if (this.addPeriod_data.timeslot == '') {
    //     return this.$message.error('请选择截止时间')
    //   } else {
    //     this.getAddPeriod()
    //   }
    // },
    //提交添加周期账单
    // async getAddPeriod () {
    //   let res = await apiAddPeriodBill({
    //     uid: this.addPeriod_data.uid,
    //     timeslot: this.addPeriod_data.timeslot
    //   })
    //   if (res.errno == 1) {
    //     this.$message.error(res.message)
    //   }
    //   if (res.errno == 0) {
    //     this.$message.success(res.message)
    //     this.dialogTableVisible = false
    //     this.reset_inquireTimeBill
    //   }
    // },

    //控制每一页多少条
    handleSizeChange (val) {
      this.page_sizes = val
      this.gatapiManageBill()
    },
    // handleSizeChange_2 (val) {
    //   this.page_sizes_2 = val
    //   this.inquireTimeBill()
    // },
    //控制当前页
    handleCurrentChange (val) {
      this.page_size = val
      this.getALLapiManageBill()
    },
    // handleCurrentChange_2 (val) {
    //   this.page_size_2 = val
    //   this.inquireTimeBill()
    // },
    //付款
    payment (id, type, order) {
      this.is_order = order
      this.audit_id = id
      this.audit_type = type
      this.audit_show = true
    },
    //补充索引
    tableRowClassName ({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    // 展开行
    async expand_change (row, expandedRows) {
      let flag = true
      for (const key in this.record) {
        if (this.record[key] == row.id) {
          flag = false
        }
      }
      if (flag) {
        this.soid = row.id
        this.record.push(row.id)
        let resp = await this.gatapiManageBill(true, row.index, true)
        this.$set(this.period_order, row.index, resp)
        this.table_loading = false
      }


    },
    //时间再封装
    getTimeType (time) {
      let date = ''
      common.formatDate(time, (y, m, d) => {
        date = `${y}-${m}-${d}`
      })
      return date
    },
    //对账单显示
    is_reset_inquire () {
      this.inquire = {
        //渠道id
        qdid: '',
        //仓库id
        ckid: '',
        //推荐人手机号
        tjmobile: '',
        //用户手机号
        mobile: '',
        // 状态
        status: '',
        // 账单类型
        fdtype: '',
        // 结算类型
        type: '',
        // 报价方案ID
        bjid: '',
        // 物流单号
        wlnum: '',
        // 账单号
        payid: '',
        // 订单号
        orderid: '',
        // 对公\对私
        ptp: '',
        // 时间段
        zdtime_start: '',
        zdtime_end: '',
      },
        this.statement_account = !this.statement_account
      if (this.statement_account) {
        this.getApiTimeBill()
      } else {
        this.getALLapiManageBill()
      }
    },

    //重置周期账单搜索
    async reset_inquireTimeBill () {
      this.inquire = {
        //渠道id
        qdid: '',
        //仓库id
        ckid: '',
        //推荐人手机号
        tjmobile: '',
        //用户手机号
        mobile: '',
        // 状态
        status: '',
        // 账单类型
        fdtype: '',
        // 结算类型
        type: '',
        // 报价方案ID
        bjid: '',
        // 物流单号
        wlnum: '',
        // 账单号
        payid: '',
        // 订单号
        orderid: '',
        // 对公\对私
        ptp: '',
        // 时间段
        zdtime_start: '',
        zdtime_end: '',
      }
      this.inquireTimeBill()
    },
    //搜索周期账单
    async inquireTimeBill (flag) {
      if (flag) {
        this.page_size_2 = 1
      }
      if ((this.inquire.zdtime_start == '' && this.inquire.zdtime_end !== '') || (this.inquire.zdtime_start !== '' && this.inquire.zdtime_end == '')) {
        return this.$message.error('时间查询需要输入开始时间和结算时间')
      }
      this.table_loading = true
      let res = await apiTimeBill({
        page: this.page_size_2,
        pageSize: this.page_sizes_2,
        status: this.inquire.status,
        payid: this.inquire.payid,
        zdtime: this.inquire.zdtime_start == '' || this.inquire.zdtime_end == '' ? null : JSON.stringify({
          zdtime: {
            start: this.inquire.zdtime_start,
            end: this.inquire.zdtime_end,
          }
        })
      })
      if (res.errno == 1) {
        this.$message.error(res.message)
        this.periodData = []
      } else {
        this.periodData = res.soalist
        this.page_number_2 = parseInt(res.totalNum)
      }

      this.table_loading = false

    },
    //获取对账单的数据
    async getApiTimeBill () {
      this.table_loading = true
      let res = await apiTimeBill({
        page: this.page_size_2,
        pageSize: this.page_sizes_2
      })
      if (res.errno == 0) {
        this.periodData = res.soalist
        // this.expand_2.push(this.periodData[0].id)
        this.soid = this.periodData[0].id
        let resp = await this.gatapiManageBill(true, 0)
        this.$set(this.period_order, 0, resp)
        this.page_number_2 = parseInt(res.totalNum)
      } else {

      }

      this.table_loading = false

    },


    //判断是否显示操作
    is_operation (s, f) {
      if (s == 0 || (s == 2 && f == 3)) {
        this.operation = true
      } else {
        this.operation = false
      }
    },
    // 重置查询
    async reset_inquire () {
      this.time_inquire = ''
      this.inquire = {
        //渠道id
        qdid: '',
        //仓库id
        ckid: '',
        //推荐人id
        tjuid: '',
        //用户id
        uid: '',
        // 状态
        status: '',
        // 账单类型
        fdtype: '',
        // 结算类型
        type: '',
        // 报价方案ID
        bjid: '',
        // 物流单号
        wlnum: '',
        // 账单号
        payid: '',
        // 订单号
        orderid: '',
        // 对公\对私
        ptp: '',
        // 时间段
        zdtime_start: '',
        zdtime_end: '',
      }
      this.page_size = 1
      this.getALLapiManageBill()
    },
    //类型转换
    type_conversion (type, data) {
      data = parseInt(data)
      if (type == 1) {
        //订单类型
        switch (data) {
          case 0:
            return '订单'
          case 1:
            return '改址费'
          case 2:
            return '附加费'
          case 3:
            return '待回收货款'
          case 4:
            return '手续费账单'
          case 5:
            return '报关费账单'
          case 6:
            return '退货账单'
          default:
            return '其他待定'
        }
      } else if (type == 2) {
        //支付方式
        switch (data) {
          case 1:
            return '微信'
          case 2:
            return '支付宝'
          case 3:
            return '银行转账'
          case 4:
            return '系统钱包'
          case 5:
            return '现金'
          default:
            return '其他'
        }
      } else if (type == 3) {
        //订单状态
        switch (data) {
          case 0:
            return '未付款'
          case 1:
            return '待审核已付款'
          case 2:
            return '已付款'
          // case 3:
          //   return '部分付款'
          case 4:
            return '到付订单'
          case -1:
            return '已生成周期结算帐单或拒申请提现'
          case -2:
            return '到付订单'
          default:
            return '其他'
        }
      } else if (type == 4) {
        switch (data) {
          case 0:
            return '未付款'
          case 1:
            return '待审核已付款'
          case 2:
            return '已付款'
          // case 3:
          //   return '部分付款'
          case 4:
            return '已开票'
          case -1:
            return '已生成周期结算帐单或拒申请提现'
          case -2:
            return '到付订单'
          default:
            return '其他'
        }
      } else if (type == 5) {
        //报价方案
        for (const key in this.bjlist) {
          if (this.bjlist[key].id == data) {
            return this.bjlist[key].bjname
          }
        }
      } else if (type == 6) {
        //渠道
        for (const key in this.qdlist) {
          if (this.qdlist[key].id == data) {
            return this.qdlist[key].channelname
          }
        }
      }
      else if (type == 7) {
        //渠道
        for (const key in this.cklist) {
          if (this.cklist[key].id == data) {
            return this.cklist[key].name
          }
        }
      }
    },

    //获取所有订单数据
    async getALLapiManageBill () {
      this.table_loading = true
      let res = await apiManageBill({
        pageSize: this.page_sizes,
        page: this.page_size,
        pd: 'getlist',
        soaid: this.soid !== '' && flag ? this.soid : null,
        qdid: this.inquire.qdid === '' ? null : this.inquire.qdid,
        ckid: this.inquire.ckid === '' ? null : this.inquire.ckid,
        mobile: this.inquire.mobile === '' ? null : this.inquire.mobile,
        tjmobile: this.inquire.tjmobile === '' ? null : this.inquire.tjmobile,
        status: this.inquire.status === '' ? null : this.inquire.status,
        fdtype: this.inquire.fdtype === '' ? null : this.inquire.fdtype,
        type: this.inquire.type === '' ? null : this.inquire.type,
        bjid: this.inquire.bjid === '' ? null : this.inquire.bjid,
        wlnum: this.inquire.wlnum === '' ? null : this.inquire.wlnum,
        payid: this.inquire.payid === '' ? null : this.inquire.payid,
        orderid: this.inquire.orderid === '' ? null : this.inquire.orderid,
        ptp: this.inquire.ptp === '' ? null : this.inquire.ptp,
        zdtime: this.inquire.zdtime_start != '' && this.inquire.zdtime_start != '' ? JSON.stringify({ start: this.inquire.zdtime_start, end: this.inquire.zdtime_end }) : null,
        // zdtime_end: this.inquire.zdtime_end === '' ? null : this.inquire.zdtime_end,
      })
      this.tableData = common.transform(res.orderlist)
      this.qdlist = common.transform(res.qdlist)
      this.cklist = common.transform(res.cklist)
      this.bjlist = common.transform(res.bjlist)
      this.page_number = parseInt(res.totalNum)
      if (res.errno == 0) {
        for (const key in this.tableData) {
          common.formatDate(this.tableData[key].createtime, (y, m, d, h, min, s) => {
            this.tableData[key].createtime = `${y}-${m}-${d} ${h}:${min}:${s}`
          })
          this.tableData[key].tj = (this.tableData[key].tj / 1000000).toFixed(2)
        }
        this.$message.success(res.message)

      } else {
        this.$message.error(res.message)
      }

      this.table_loading = false

    }
  },
  mounted () {

  },
  created () {
    this.getALLapiManageBill()
  }
}
</script>

<style lang="scss">
@import "@/assets/css/variable.scss";
.myBill {
  width: 100%;
  height: 100%;
  display: flex;
  align-content: flex-start;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .myBill_table,
  .myBill_top {
    width: 95%;
    flex: 1;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 4px;
    .header_view {
      display: flex;
      .el-input__inner {
        border-right: 0;
        border-radius: 4px 0 0 4px !important;
      }
      .el-button {
        border-left: 0;
        border-radius: 0 4px 4px 0 !important;
      }
    }
    .operationClass {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
  .myBill_table {
    margin-bottom: 10px;
    .interior_table {
      background-color: #d4e6e64f;
    }
  }
  .el-pagination {
    flex: 1;
    max-height: 70px;
    display: flex;
    align-items: center;
  }
  .myBill_top {
    max-height: 120px;
    min-height: 120px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    .top_item {
      min-width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 20px;
      span {
        margin-bottom: 5px;
        color: #333;
        font-size: 14px;
      }
    }
  }

  .allorders_title {
    margin-top: -10px;
    width: 100%;
    height: 30px;
    padding-left: 2.5%;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
    // border-bottom: 2px dashed #cccccc;
    transition: all 0.3s;
    background-color: #ffffff;
  }
  .myBill_inquire {
    margin-top: 20px;
    width: 95%;
    // height: 200px;
    background-color: #fff;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.192);
    .el-form {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      // height: 70%;
      align-content: flex-start;

      .inquire_item {
        min-width: 300px;
        display: flex;
        margin: 0;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;
        width: 20%;
        height: 50%;
        .el-form-item__label {
        }
        .el-input {
          width: 200px;
        }
      }
      .time_inquire {
        width: 30%;
      }
    }
    .inquire_button {
      width: 100%;
      height: 30%;
      .inquire_search_but {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        box-sizing: border-box;
        padding-right: 20px;
      }
    }
  }
  .order_form::before {
    box-shadow: 0 0px 10px 1px black;
  }
  .myBill_main {
    margin-top: 20px;

    width: 95%;
    height: 70%;
    background-color: #ffffff;
    .el-icon-coin,
    .el-icon-bank-card {
      width: 50%;
    }
    .bill {
      margin: 0 auto;
    }
    .bill::before {
      background-color: #000;
    }
    .el-table {
      .el-table--border::after {
        background-color: #000;
      }
    }
  }
  .el-tooltip {
    width: 100%;
    display: block;
    height: 100%;
  }
  .audit {
    .el-form-item {
      .el-form-item__label {
        width: 100px;
      }
      .el-input {
        width: 80%;
      }
      .el-form-item__error {
        margin-left: 100px;
      }
    }
  }
}
.manage {
  .myBill_inquire {
    // height: 250px;

    .el-form {
      // height: 60%;
      .el-form-item__label {
        width: 100px;
      }
    }
  }
  .myBill_main {
    // background-color: #40a0ff1f;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .paging {
      height: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .addPeriod {
    min-width: 300px;

    .el-dialog__body {
      padding-bottom: 0;
    }
    .period {
      width: 100%;
      height: 200px;
      // background-color: pink;
      .el-input {
        min-width: 200px;
        max-width: 300px;
      }
      .el-form-item__label {
        width: 100px;
      }
    }
  }
}
</style>